import { Typography } from '@mui/material'
import type React from 'react'
import type { ReactNode } from 'react'

// import "./CustomTitle.css";

type CustomTitleProps = {
  children: ReactNode
}

export const CustomTitle: React.FC<CustomTitleProps> = props => {
  return (
    <Typography
      sx={{
        color: '#282828',
        font: 'normal normal bold 32px/48px Noto Sans JP',
        mt: '6px',
        whiteSpace: 'pre-line',
      }}
    >
      {props.children}
    </Typography>
  )
}
